import { Spinner } from '@fe/common/components/Spinner'

export const CashDetails: React.FC = () => (
  <>
    <Spinner />
  </>
)
